import template from './layout.template.html'

export default {
  template
}
